<template src="./create-quiz.html"></template>
<script>
import createPopupQuiz from "./create-popup-quiz/create-popup-quiz";
import quizService, { parseQuizUpdatedVersionResponse } from "../../services/quiz-service";
import tagService from "../../services/tag-service";
import sessionService from "../../services/session-service";
import storageService from "../../services/storage-service";
import videoService from "../../services/video-service";
import validatorService from "../../services/validator-service";
import VueTagsInput from "@johmun/vue-tags-input";
import ClickOutside from "vue-click-outside";
import VueJsonToCsv from "vue-json-to-csv";
import Vue from "vue";
import moment from "moment";
import quizConfigurationService from "../../services/quiz-configuration-service";
import courseTopicService from "../../services/course-topic-service";
import courseSubTopicService from "../../services/course-sub-topic-service";
import _ from "lodash";
import {
  readQuestionFromCSV,
  readFileContent,
  csvSocketinit,
  exportToCSV,
} from "../../services/csvService";
import {
  convertQuizJsonFileToCsv,
  downloadSampleQuizJson as triggerSampleQuizJsonDownload,
  isQuizJsonFile,
} from "../../services/quizJsonUploadService";
import omrService from "../../services/omr-service";
import {
  parseCsvValidationLines,
  parseCsvSocketFatalError,
  applyOmrImportFailure,
  applyOmrImportSuccess,
  applyUploadResultToVm,
  extractApiErrorMessage,
} from "../../services/upload-error-service";

const DEFAULT_TEACHER_CHECK_WINDOW_HOURS = 24;

function Stack() {
  this.stac = new Array();
  this.pop = function () {
    return this.stac.pop();
  };
  this.push = function (item) {
    this.stac.push(item);
  };
}
export default {
  name: "app-create-quiz",
  components: {
    "app-create-popup-quiz": createPopupQuiz,
    "vue-json-to-csv": VueJsonToCsv,
    VueTagsInput,
  },
  directives: {
    ClickOutside,
  },
  data: function () {
    return {
      disable1: true,
      instructor_id: -1,
      editMode: false,
      createdQuizId: "",
      previousQuizId: "",
      quiz: { result_delay_in_hours: 0, ai_model: 'gpt-3.5' ,is_direct_check:false},
      quizType: "full",
      omr_sheet_layout: "mdcat_manzil_180",
      stack: new Stack(),
      moduleOrChapter: 0,
      moduleOrChapterId: 0,
      percentCompleted: 0,
      uploadingFile: false,
      newVersion: false,
      automaticQuiz: false,
      dataValidated: false,
      activeAiQuiz: false,
      chevronListBox: "",
      windowType: 1,
      isPopUp: false,
      popupType: 0,
      isDelayInResult: false,
      isCourseFocused: false,
      isModuleFocused: false,
      isChapterFocused: false,
      isVideoFocused: false,
      isSessionFocused: false,
      isFacultyFocused: false,
      courseNotFound: false,

      selectedCourse: { name: "Click here to Select Course" },
      selectedModule: { name: "Click here to Select Module" },
      selectedChapter: { name: "Click here to Select Chapter" },
      selectedVideo: { name: "Click here to Select Video" },

      session: { name: "Default Session", description: "Default Session", start_time: moment().format(), end_time: moment().add(6,'M').format() },
      sessionOld: { name: "", description: "", start_time: "", end_time: "" },
      itemListCourses: [],
      itemListModules: [],
      itemListChapters: [],
      itemListVideos: [],
      itemListSessions: [],
      allSessions: [],

      inputValueCourse: "",
      inputValueModule: "",
      inputValueChapter: "",
      inputValueVideo: "",
      inputValueSession: "",

      apiLoadedCourse: false,
      apiLoadedModule: false,
      apiLoadedChapter: false,
      apiLoadedVideo: false,
      apiLoadedSession: false,
      uploadingCSV: false,
      isCSVUpload: false,
      uploadingOmrJson: false,
      omrJsonFileName: "",
      omrImportedCount: 0,
      omrImportTaxonomy: null,

      loadingCourse: false,
      loadingModule: false,
      loadingChapter: false,
      loadingVideo: false,
      faculty: "",
      faculties: [],
      selectedFaculties: [],
      selectedFacultiesForAutoQuiz: [],
      selectedTagsForAutoQuiz: [],
      difficulty_level: "Easy",
      tags: [],
      tag: "",
      questionsCount: "",
      csvFileName: "",
      topics: [],
      callcheck: {
        AllFaculties: false,
        ModulesByCourseId: false,
        video: false,
        GeneralSessionByQuizId: false,
      },
      warnings: [],
      errors: [],
      questions: [],
      uploadErrorSummary: "",
      validation_errors: {},
      sampleCSV: process.env.VUE_APP_DOWNLOAD_empty_CSV,
      omrSampleJsonUrl: omrService.getSampleJsonUrl(),
      errorVideo: false,
      showLoader:false,
      editQuizLoading: false,
      is_direct_check:false,
      checking_type: 'ai_only',
      teacher_check_window_hours: DEFAULT_TEACHER_CHECK_WINDOW_HOURS,
      is_zero_server:false,
      is_immediate_result: false,
      is_negative_marking: false,
      negative_marking_per_question: 0.25,

      // Configuration & Topic Dropdowns
      configurations: [],
      selectedConfigurations: [],
      selectedTopics: [],
      configSearch: "",
      topicSearch: "",
      loadingConfig: false,
      loadingTopic: false,
      showConfigDropdown: false,
      showTopicDropdown: false,
      apiLoadedConfig: false,
      apiLoadedTopic: false,
      
      // Subtopic Data
      subtopics: [],
      selectedSubTopics: [],
      subTopicSearch: "",
      loadingSubTopic: false,
      showSubTopicDropdown: false,
      apiLoadedSubTopic: false,

      // Pagination
      topicPage: 1,
      topicTotalPages: 1,
      subTopicPage: 1,
      subTopicTotalPages: 1,

      // Select-all across all pages (not just currently loaded page)
      selectingAllTopics: false,
      selectingAllSubTopics: false,
    };
  },
  props: {
    quizData: {
      type: Object,
    },
    quizPrefetched: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    quiz: {
      handler(quiz) {
        if (quiz.passing_percentage && quiz.passing_percentage > 100) {
          this.quiz.passing_percentage = null;
        }
        if (quiz.mins && quiz.mins > 59) {
          this.quiz.mins = null;
        }
      },
      deep: true,
    },

    windowType: function() {
        this.$parent.popCpTop();
    },

    selectedConfigurations(newVal) {
      if (newVal && newVal.length > 0) {
        this.quiz.configuration_id = newVal.map(c => c._id);
      }
    },
    selectedTopics(newVal) {
      if (newVal && newVal.length > 0) {
        this.quiz.topic_id = newVal.map(t => t._id);
      }
    },
    selectedSubTopics(newVal) {
      if (newVal && newVal.length > 0) {
        this.quiz.sub_topic_id = newVal.map(st => st._id);
      }
    },
  },
  mounted() {
    this.atCreation();
    this.popupItem = this.$el;
    document.addEventListener('click', this.globalClickEventHandler, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.globalClickEventHandler, true);
  },
  computed: {
    filteredItems() {
      return this.faculties.filter((i) => {
        return i.text.toLowerCase().indexOf(this.faculty.toLowerCase()) !== -1;
      });
    },
    filteredItemsForTags() {
      return this.tags.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
    omrImportComplete() {
      const hasQuestions = Array.isArray(this.questions) && this.questions.length > 0;
      return (
        this.quizType === "omr" &&
        !this.uploadingOmrJson &&
        !this.errors.length &&
        (hasQuestions || this.omrImportedCount > 0)
      );
    },
    omrImportedTotal() {
      if (this.questions && this.questions.length) return this.questions.length;
      return this.omrImportedCount || 0;
    },
    omrPreviewQuestions() {
      return (this.questions || []).slice(0, 15);
    },
  },
  created() {
    this.instructor_id = storageService.get("uid");
    if (this.quizData) {
      this.editMode = true;
      this.editQuizLoading = true;
    } else {
      this.bootstrapAuxiliaryData(false);
    }
  },
  methods: {
    secondsToHms(seconds) {
      seconds = Number(seconds);
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = Math.floor((seconds % 3600) % 60);
      return { h, m, s };
    },
    hideCourse() {
      this.isCourseFocused = false;
    },
    hideModule() {
      this.isModuleFocused = false;
    },
    hideChapter() {
      this.isChapterFocused = false;
    },
    hideVideo() {
      this.isVideoFocused = false;
    },
    hideFaculty() {
      this.isFacultyFocused = false;
    },
    createNewVersion() {
      this.newVersion = true;
      this.firstWindowHandler(6);
    },
    async emptyCsv() {
      try {
        let link = process.env.VUE_APP_DOWNLOAD_empty_CSV;
        window.location.href = link;
        if (link) {
          this.$toast("File Downloaded");
        }
      } catch (error) {
        this.$toast.error("Error in file download");
      }
    },
    async saveSession(data, type) {
      try {
        let response;
        if (this.editMode) {
          if (this.newVersion) {
            data.quiz_id = this.quiz._id;
            response = await sessionService.createSession(data);
          } else {
            data._id = this.session._id;
            data.questionsRequired = true;
            response = await sessionService.updateSession(data);
          }
        } else {
          response = await sessionService.createSession(data);
        }
        if (response) {
          if (response.data.status === "success") {
            this.session = response.data.data.session;
            if (this.editMode) {
              this.$toast.info("Quiz Updated Successfully");
              if (
                response.data.data.questions &&
                response.data.data.questions.length
              ) {
                this.questions = response.data.data.questions;
              }
              if (this.questions && this.questions.length) {
                if (this.quizType !== "pop") {
                  const routeData = {
                    name: "edit-quiz-questions",
                    params: { questions: this.questions, quiz: this.quiz },
                    query: {
                      quizId: this.createdQuizId,
                      quizType: this.quizType,
                      type: this.moduleOrChapter,
                      id: this.moduleOrChapterId,
                      instructorId: this.instructor_id,
                      ai: this.quiz.ai_quiz_active,
                    },
                  };
                if (this.$route.query.question_no) {
                  routeData.query.question_no = this.$route.query.question_no;
                }
                  this.$router.push(routeData);
                } else {
                  this.windowType = 2;
                }
              } else {
                if (this.quizType === "pop") {
                  this.windowType = 2;
                } else {
                  this.windowType = type;
                }
              }
            } else {
              this.$toast.info("Quiz Created Successfully");
              if (this.quizType === "pop") {
                this.windowType = 2;
              } else {
                this.windowType = type;
              }
            }
          } else {
            this.$toast.warning(response.data.message);
          }
        }
      } catch (error) {
        if (error.response) {
          this.$toast.error(error.response.data.errors[0].messages[0]);
        } else if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    
    continuePopQuiz() {
      this.firstWindowHandler(6);
      // this.$parent.popCpTop();
    },
    async getGeneralSessionByQuizId(id) {
      try {
        let response = await sessionService.getGeneralSessionByQuizId(id);
        if (response) {
          this.callcheck.GeneralSessionByQuizId = true;
          if (this.check() === true) {
            this.dataValidated = false;
          }
          this.session = response.data.data.session;
          this.session.start_time = moment(this.session.start_time).format(
            "YYYY-MM-DDThh:mm"
          );
          this.session.end_time = moment(this.session.end_time).format(
            "YYYY-MM-DDThh:mm"
          );
        }
      } catch (error) {
        if (error.response) {
          this.$toast.error(error.response.data.message);
        } else if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    async getAutoGeneratedQuiz() {
      try {
        let facIds = [];
        this.selectedFacultiesForAutoQuiz.forEach((faculty) => {
          facIds.push(faculty.id);
        });
        let tagsNames = [];
        if (this.selectedTagsForAutoQuiz.length) {
          this.selectedTagsForAutoQuiz.forEach((tag) => {
            tagsNames.push(tag.text);
          });
        }
        tagsNames.push(this.difficulty_level);
        let data = {
          tagNames: tagsNames,
          facultyIds: facIds,
          questionsCount: this.questionsCount,
        };
        const fields = ["questionsCount"];
        let isDataValidated = await validatorService.validate(fields, data);
        if (isDataValidated) {
          throw new Error(isDataValidated);
        } else {
          try {
            const response = await quizService.getAutoGeneratedQuiz(data);
            if (response) {
              if (response.data.status === "success") {
                if (response.data.data.questions.length) {
                  this.questions = JSON.stringify(response.data.data.questions);
                  this.questions = JSON.parse(this.questions);
                  let allTags = [];
                  response.data.data.questions.forEach((question) => {
                    question.tags.forEach((tag, i) => {
                      if (tag.tag_type === "general") {
                        allTags.push(tag.tag_name);
                        question.tags[i] = tag.tag_name;
                      }
                    });
                  });
                  allTags = [...new Set(allTags)];
                  this.topics = [];
                  allTags.forEach((tag) => {
                    let count = 0;
                    response.data.data.questions.forEach((question) => {
                      let value = question.tags.includes(tag);

                      if (value) {
                        count++;
                      }
                    });
                    this.topics.push({ name: tag, count: count });
                  });
                  this.firstWindowHandler(88);
                } else {
                  this.$toast.warning("No Questions found under this filter");
                }
              } else {
                this.$toast.info(response.data.message);
              }
            }
          } catch (error) {
            if (error.response) {
              this.$toast.error(error.response.data.message);
            } else if (error.message) {
              this.$toast.error(error.message);
            } else {
              this.$toast.error(error);
            }
          }
        }
      } catch (error) {
        if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    chevronListBoxHandler() {
      this.chevronListBox = !this.chevronListBox;
    },
    getCSVUploadResults(res) {
      const parsed = parseCsvValidationLines(res.data.data.warnings || []);
      applyUploadResultToVm(this, parsed);
      let questions = res.data.data.questions || [];
      if (this.quizType === 'daq') {
        questions = questions.map((q) => {
          const level = q.question_type_level
            ? String(q.question_type_level).trim().toLowerCase()
            : '';
          return {
            ...q,
            quiz_type: 'daq',
            options: null,
            question_type_level: ['long', 'short', 'numerical'].includes(level)
              ? level
              : '',
            total_marks: Number(q.total_marks) > 0 ? Number(q.total_marks) : 100,
            allow_ocr: q.allow_ocr !== false,
            ai_config: q.ai_config || {
              content: true,
              understanding: true,
              writing_skill: true,
              evidence: true,
              organization: true,
            },
          };
        });
      }
      this.questions = questions;
      if (parsed.errors.length) {
        this.$toast.error(parsed.summary);
      } else if (parsed.warnings.length) {
        this.$toast.warning(parsed.summary);
      }
    },
    downloadDaqSampleCsv() {
      const header = [
        'ind_number',
        'question',
        'image_url',
        'equation',
        'tags',
        'difficulty_level',
        'question_type_level',
        'total_marks',
        'weightage',
        'section',
        'paragaph',
        'related_video_id',
        'solution',
        'solution_equation',
        'solution_image_url',
        'allow_ocr',
        'configurations',
        'topics',
        'sub_topics',
        'learning_outcomes',
      ];
      const rows = [
        header,
        [
          '1',
          'Explain the process of photosynthesis in plants.',
          '',
          '',
          'Biology+Plant',
          'Medium',
          'long',
          '100',
          '5',
          'Biology',
          '',
          '',
          'Write a complete explanation covering light and dark reactions.',
          '',
          '',
          'TRUE',
          'Biology Config',
          'Photosynthesis',
          'Light Reaction|Dark Reaction',
          'LO1|LO2',
        ],
        [
          '2',
          "Define Newton's second law of motion.",
          '',
          '',
          'Physics',
          'Easy',
          'short',
          '50',
          '3',
          'Physics',
          '',
          '',
          'F = ma',
          '',
          '',
          'TRUE',
          'Physics Config',
          'Laws of Motion',
          'Force',
          'LO3',
        ],
        [
          '3',
          'A car accelerates from 0 to 20 m/s in 5 s. Find acceleration.',
          '',
          '',
          'Physics+Numerical',
          'Hard',
          'numerical',
          '100',
          '5',
          'Physics',
          '',
          '',
          'a = (v-u)/t = 4 m/s^2',
          '',
          '',
          'TRUE',
          'Physics Config',
          'Kinematics',
          'Acceleration',
          'LO4',
        ],
      ];
      exportToCSV(rows, 'sample-nearpeer-daq-csv.csv');
    },
    downloadSampleQuizJson() {
      triggerSampleQuizJsonDownload(this.quizType === 'daq' ? 'daq' : 'full');
    },
    async fileChooser() {
      try {
        this.uploadingCSV = true;
        var input = document.createElement("input");
        input.type = "file";
        input.accept = ".csv,.json,text/csv,application/json";
        input.onchange = this.inputChangeHandler;
        input.click();
      } catch (error) {
        if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    firstWindowHandler(type) {
      if (type === 4) {
        this.automaticQuiz = true;
        this.selectedFacultiesForAutoQuiz = [...this.selectedFaculties];
      }
      if (type === 6) {
        this.createQuiz(type);
      } else if (type === 77) {
        this.fileChooser();
      } else {
        this.windowType = type;
      }
    },
    backMethod() {
      if (this.$route.query.editType) {
        this.$router.replace({ query: {} });
      }
      this.$parent.popupClose();
    },
    async atCreation() {
      Object.keys(this.callcheck).forEach((element) => {
        this.callcheck[element] = false;
      });
      if (this.quizData) {
        this.editMode = true;
        this.editQuizLoading = true;
        try {
        if (this.editMode === true) {
          this.dataValidated = true;
        }
        this.createdQuizId = this.quizData._id;
        const isOmrEdit = this.quizData.quiz_type === "omr";
        const updatedQuiz = this.quizPrefetched
          ? { data: { data: { quiz: this.quizData } } }
          : await quizService.getQuizUpdatedVersion(
            this.quizData._id,
            isOmrEdit ? { light: true } : {}
          );
        if (updatedQuiz && updatedQuiz.data.data.quiz) {
          this.quiz = updatedQuiz.data.data.quiz;
          if(!this.quiz.ai_model) {
            this.quiz.ai_model = 'gpt-3.5'
          }
          if(updatedQuiz.data.data.quiz.is_direct_check) {
            this.is_direct_check = true;
          }
          if(updatedQuiz.data.data.quiz.checking_type) {
            this.checking_type = updatedQuiz.data.data.quiz.checking_type;
          }
          if(updatedQuiz.data.data.quiz.teacher_check_window_hours) {
            this.teacher_check_window_hours = updatedQuiz.data.data.quiz.teacher_check_window_hours;
          }
          if(updatedQuiz.data.data.quiz.is_zero_server) {
            this.is_zero_server = true;
            // Check if immediate result is enabled
            if(updatedQuiz.data.data.quiz.is_immediate_result) {
              this.is_immediate_result = true;
            }
          }
          if(updatedQuiz.data.data.quiz.is_negative_marking) {
            this.is_negative_marking = true;
            this.negative_marking_per_question = updatedQuiz.data.data.quiz.negative_marking_per_question || 0.25;
          }
          if (updatedQuiz.data.data.quiz.omr_sheet_layout) {
            this.omr_sheet_layout = typeof updatedQuiz.data.data.quiz.omr_sheet_layout === 'string'
              ? updatedQuiz.data.data.quiz.omr_sheet_layout
              : (updatedQuiz.data.data.quiz.omr_sheet_layout.preset || 'mdcat_manzil_180');
          }
          this.previousQuizId = this.quiz.session_id;
        } else {
          this.quiz = this.quizData;
        }
        // this.getAllFaculties();
        this.selectedCourse = this.quiz.course;
        this.selectedModule = this.quiz.module;
        this.selectedChapter = this.quiz.chapter;
        this.selectedVideo = this.quiz.video;
        
        // Populate configuration and topic if available (not used for OMR JSON quizzes)
        const isOmrQuiz = (this.quiz.quiz_type || this.quizData.quiz_type) === "omr";
        if (this.quiz.configuration_id && !isOmrQuiz) {
             let configIds = [];
             if (Array.isArray(this.quiz.configuration_id)) {
                 configIds = this.quiz.configuration_id;
             } else { // Handle single ID (legacy or object)
                  // If it's an object, extract _id, if string, use it
                  const val = this.quiz.configuration_id;
                  configIds = [val._id || val]; 
             }
             
             // Fetch configurations first to resolve IDs
             await this.fetchConfigurations(); 
             
             // Map IDs to objects
             if (this.configurations.length) {
                 this.selectedConfigurations = this.configurations.filter(c => configIds.includes(c._id));
             }
             
             // Now fetch topics based on selected configs
             if (this.selectedConfigurations.length > 0) {
                 await this.fetchTopics();
                 
                 // Populate selected topics
                 if (this.quiz.topic_id) {
                     let topicIds = [];
                     if (Array.isArray(this.quiz.topic_id)) {
                         topicIds = this.quiz.topic_id;
                     } else {
                         const val = this.quiz.topic_id;
                         topicIds = [val._id || val];
                     }
                     
                     if (this.topics.length) {
                         this.selectedTopics = this.topics.filter(t => topicIds.includes(t._id));
                     }
                 }
                 
                 // Now fetch subtopics based on selected topics
                 if (this.selectedTopics.length > 0) {
                    const res = await this.fetchSubTopics();                     
                     // Populate selected subtopics
                     let subTopicIds = [];
                     const potentialSubtopicField = this.quiz.sub_topic_id || this.quiz.subtopics || this.quiz.sub_topics;

                     if (potentialSubtopicField && Array.isArray(potentialSubtopicField) && potentialSubtopicField.length > 0) {
                         subTopicIds = potentialSubtopicField.map(id => (id && typeof id === 'object') ? (id._id || id) : id);
                     } else if (potentialSubtopicField && !Array.isArray(potentialSubtopicField)) {
                         const val = potentialSubtopicField;
                         subTopicIds = [(val && typeof val === 'object') ? (val._id || val) : val];
                     }

                     // Fallback: Check questions if root subtopics are empty
                     if (subTopicIds.length === 0 && this.quiz.questions && this.quiz.questions.length > 0) {
                         const allSubtopics = this.quiz.questions.reduce((acc, q) => {
                             if (q.subtopics && Array.isArray(q.subtopics)) {
                                 return acc.concat(q.subtopics);
                             }
                             return acc;
                         }, []);
                         // Deduplicate IDs
                         subTopicIds = [...new Set(allSubtopics.map(id => (id && typeof id === 'object') ? (id._id || id) : id))];
                     }

                     if (this.subtopics.length && subTopicIds.length) {
                         this.selectedSubTopics = this.subtopics.filter(st => subTopicIds.includes(st._id));
                     }
                 }
             }
        }
        if (this.quiz.result_delay_in_hours > 0) {
          this.isDelayInResult = true;
        } else {
          this.isDelayInResult = false;
        }
        if (this.selectedModule.id) {
          this.getModulesByCourseId(this.selectedCourse.id);
          this.moduleOrChapter = 1;
          this.moduleOrChapterId = this.selectedModule.id;
          this.getVideos();
        }
        if (this.selectedChapter?.id) {
          this.getChapterByModuleId(this.selectedModule.id);
          this.moduleOrChapter = 2;
          this.moduleOrChapterId = this.selectedCourse.id;
          this.getVideos();
        }
        if (this.quiz.duration) {
          const time = this.secondsToHms(this.quiz.duration);
          this.quiz.hours = time.h;
          this.quiz.mins = time.m;
        }
        const resolvedType = this.quiz.quiz_type || this.quizData.quiz_type;
        if (resolvedType) {
          this.popUpQuizHandler(resolvedType);
        } else {
          this.quizType = "full";
        }
        this.createdQuizId = this.quiz._id;
        this.getGeneralSessionByQuizId(this.quiz._id);
        } catch (error) {
          console.error(error);
          this.$toast.error("Failed to load quiz details");
        } finally {
          const isOmrQuiz = (this.quiz.quiz_type || this.quizData?.quiz_type) === "omr";
          this.bootstrapAuxiliaryData(isOmrQuiz);
          this.editQuizLoading = false;
        }
      }
      if(this.$route.query.question_no) {
        this.showLoader=true;
        setTimeout(()=>{
          this.continuePopQuiz();
        },2000)
      } 
    },
    backBtn(wintype) {
      if (wintype == 6) {
        this.editMode = true;
        this.firstWindowHandler(1);
      } else if (wintype == 4, wintype == 3) {
        this.windowType = 6;
      } else {
        this.firstWindowHandler(1);
      }
      this.atCreation();
      this.dataValidated = false;
    },
    bootstrapAuxiliaryData(isOmrQuiz = false) {
      this.getAllTags();
      this.getCoursesByInstructorId();
      if (!isOmrQuiz) {
        this.getAllNicheTags();
        if (!this.editMode) {
          this.fetchConfigurations();
        }
      }
    },
    popUpQuizHandler(quizType) {
      this.quizType = quizType;
      if (this.quizType === "pop") {
        this.isPopUp = true;
      } else {
        this.isPopUp = false;
      }
      if (this.quizType === "omr") {
        if (!this.quiz.passing_percentage) {
          this.quiz.passing_percentage = 50;
        }
        if (!this.quiz.hours && !this.quiz.mins) {
          this.quiz.hours = 3;
          this.quiz.mins = 0;
        }
        this.isDelayInResult = false;
        this.is_zero_server = false;
        this.is_immediate_result = true;
        this.omr_sheet_layout = this.omr_sheet_layout || "mdcat_manzil_180";
      }
    },
    retry() {
      this.getCoursesByInstructorId();
    },
    async getCoursesByInstructorId(type) {
      try {
        this.courseNotFound = false;
        this.loadingCourse = true;
        const response = await quizService.getCoursesByInstructorId(
          this.instructor_id
        );
        if (response) {
          this.loadingCourse = false;
          let courses = [];
          if (response.data.data) {
            response.data.data.forEach((course) => {
              course.courses.forEach((crs, index) => {
                crs.value = crs.id;
                courses.push(crs);
              });
            });
          }
          this.itemListCourses = courses;
          this.apiLoadedCourse = true;
        }
      } catch (error) {
        this.loadingCourse = false;
        this.courseNotFound = true;
        if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    clearCourse() {
      if (this.selectedCourse) {
        this.selectedCourse = "";
        this.selectedModule = "";
        this.selectedChapter = "";
        this.selectedVideo = "";
        this.apiLoadedModule = false;
        this.apiLoadedVideo = false;
        this.apiLoadedChapter = false;
      }
    },
    clearModule() {
      if (this.selectedModule) {
        this.selectedModule = "";
        this.selectedVideo = "";
        this.selectedChapter = "";
        this.apiLoadedVideo = false;
        this.apiLoadedChapter = false;
      }
    },
    clearVideo() {
      if (this.selectedVideo) {
        this.selectedVideo = "";
      }
    },
    async getModulesByCourseId(id) {
      try {
        this.apiLoadedModule = false;
        this.apiLoadedVideo = false;
        this.loadingModule = true;
        const response = await quizService.getModulesByCourseId(id);
        if (response) {
          this.callcheck.ModulesByCourseId = true;
          if (this.check() === true) {
            this.dataValidated = false;
          }
          this.loadingModule = false;
          if (response.data.modules.length > 0) {
            let modules = [];
            response.data.modules.forEach((mdl, index) => {
              mdl.value = mdl.id;
              modules.push(mdl);
            });
            this.itemListModules = modules;
            this.apiLoadedModule = true;
          }
        }
      } catch (error) {
        this.apiLoadedModule = true;
        this.loadingModule = false;
        if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    async getChapterByModuleId(id) {
      try {
        this.apiLoadedChapter = false;
        this.loadingChapter = true;
        const response = await quizService.getChapterByModuleId(id);
        if (response) {
          if (response.data.chapters.length > 0) {
            this.loadingChapter = false;
            let chapters = [];
            response.data.chapters.forEach((chp, index) => {
              chp.value = chp.id;
              chapters.push(chp);
            });
            this.itemListChapters = chapters;
            this.apiLoadedChapter = true;
          } else {
            this.getVideos();
          }
        } else {
          this.getVideos();
        }
      } catch (error) {
        this.apiLoadedChapter = true;
        this.loadingChapter = false;
        this.getVideos();
        if (error.message) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error(error);
        }
      }
    },
    async getVideos() {
      this.loadingVideo = true;
      try {
        let params = {
          id: this.moduleOrChapterId,
          instructor_id: this.instructor_id,
          type: this.moduleOrChapter,
        };
        let response = await videoService.getVideos(params);
        this.loadingChapter = false;
        if (response) {
          this.callcheck.video = true;
          if (this.check() === true) {
            this.dataValidated = false;
          }
          if (response.data.success && response.data.videos.length) {
            this.itemListVideos = response.data.videos;
            this.apiLoadedVideo = true;
          } else {
            this.itemListVideos = [];
          }
        }
      } catch (error) {
        this.loadingChapter = false;
        this.apiLoadedVideo = true;
        console.log(error);
      }
      this.loadingVideo = false;
    },
    async getAllFaculties() {
      const response = await quizService.getAllfaculties();
      if (response) {
        this.callcheck.AllFaculties = true;
        if (this.check() === true) {
          this.dataValidated = false;
        }
        this.faculties = [];
        response.data.data.faculties.forEach((fac) => {
          this.faculties.push({ id: fac._id, text: fac.faculty_name });
          if (this.editMode && this.quiz.faculties?.length) {
            const found = this.quiz.faculties.find(
              (element) => element === fac._id
            );
            if (found) {
              // this.selectedFaculties.push({
              //   id: fac._id,
              //   text: fac.faculty_name,
              // });
            }
          }
        });
      }
    },
    async getAllNicheTags() {
      const response = await tagService.getAllNicheTags();
      if (response) {
        this.callcheck.AllFaculties = true;
        if (this.check() === true) {
          this.dataValidated = false;
        }
        this.faculties = [];
        if (this.editMode && this.quiz.tags?.length) {
            this.selectedFaculties = this.quiz.tags;
          }
        response.data.courseTags.forEach((fac) => {
          this.faculties.push({ id: fac.id, text: fac.name });
        });
      }
    },
    async getAllFacultiesToLoad() {
      const response = await quizService.getAllfaculties();
      if (response) {
        this.faculties = [];
        response.data.data.faculties.forEach((fac) => {
          this.faculties.push({ id: fac._id, text: fac.faculty_name });
        });
      }
    },
    async getAllTags() {
      const response = await tagService.getAllTags();
      if (response) {
        this.tags = [];
        response.data.data.tag.forEach((elm) => {
          this.tags.push({ id: elm._id, text: elm.tag_name });
        });
      }
    },

    // Configuration & Topic Methods
    async fetchConfigurations(search = "") {
      this.loadingConfig = true;
      try {
        
        const response = await quizConfigurationService.getAllConfigurations("", search, false, 1, 100);
        if (response && response.data && response.data.docs) {
           this.configurations = response.data.docs;
           this.apiLoadedConfig = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingConfig = false;
      }
    },
    
    debouncedFetchConfigurations: _.debounce(function (e) {
        this.fetchConfigurations(this.configSearch);
    }, 500),

    async fetchTopics(search = "", page = 1) {
      if (!this.selectedConfigurations || !this.selectedConfigurations.length) {
          this.topics = [];
          return;
      }
      this.loadingTopic = true;
      if (page === 1) this.topicPage = 1;

      try {
        const configIds = this.selectedConfigurations.map(c => c._id);
        const response = await courseTopicService.getAllTopics(configIds, search, null, page, 20);
        
        if (response && response.data && response.data.docs) {
             if (page === 1) {
                 this.topics = response.data.docs;
             } else {
                 this.topics = [...this.topics, ...response.data.docs];
                 this.topics = _.uniqBy(this.topics, '_id');
             }
             this.topicTotalPages = response.data.totalPages || 1;
             this.apiLoadedTopic = true;
        } else if (page === 1) {
             this.topics = [];
        }
        
      } catch (error) {
        console.error(error);
        if (page === 1) this.topics = [];
      } finally {
        this.loadingTopic = false;
      }
    },

    debouncedFetchTopics: _.debounce(function (e) {
        this.fetchTopics(this.topicSearch, 1);
    }, 500),

    loadMoreTopics() {
        if (this.topicPage < this.topicTotalPages) {
            this.topicPage++;
            this.fetchTopics(this.topicSearch, this.topicPage);
        }
    },

    /**
     * Fetch every topic page for the selected configs (respects current search).
     * Used by Select All so selection is not limited to the first page.
     */
    async fetchAllTopicsPages(search = "") {
      if (!this.selectedConfigurations || !this.selectedConfigurations.length) {
        return [];
      }
      const configIds = this.selectedConfigurations.map((c) => c._id);
      const pageSize = 100;
      let page = 1;
      let totalPages = 1;
      let all = [];

      do {
        const response = await courseTopicService.getAllTopics(
          configIds,
          search,
          null,
          page,
          pageSize,
        );
        const docs = (response && response.data && response.data.docs) || [];
        all = all.concat(docs);
        totalPages = (response && response.data && response.data.totalPages) || 1;
        page += 1;
      } while (page <= totalPages);

      return _.uniqBy(all, "_id");
    },

    async selectAllTopics() {
      if (!this.selectedConfigurations.length) {
        this.$toast.warning("Please select at least one configuration first.");
        return;
      }
      if (this.selectingAllTopics) return;

      this.selectingAllTopics = true;
      this.loadingTopic = true;
      try {
        const all = await this.fetchAllTopicsPages(this.topicSearch);
        this.topics = all;
        this.topicPage = 1;
        this.topicTotalPages = 1;
        this.apiLoadedTopic = true;
        this.selectedTopics = [...all];
        // Refresh subtopic list for the newly selected topics
        this.subtopics = [];
        this.selectedSubTopics = [];
        if (all.length) {
          await this.fetchSubTopics(this.subTopicSearch, 1);
        }
        if (all.length) {
          this.$toast.success(`Selected ${all.length} topic${all.length === 1 ? "" : "s"}`);
        } else {
          this.$toast.warning("No topics found to select");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Failed to select all topics");
      } finally {
        this.selectingAllTopics = false;
        this.loadingTopic = false;
      }
    },

    deselectAllTopics() {
      this.selectedTopics = [];
      this.selectedSubTopics = [];
      this.subtopics = [];
      this.subTopicPage = 1;
      this.subTopicTotalPages = 1;
    },

    async fetchSubTopics(search = "", page = 1) {
      if (!this.selectedTopics || !this.selectedTopics.length) {
          this.subtopics = [];
          return;
      }
      this.loadingSubTopic = true;
      if (page === 1) this.subTopicPage = 1;

      try {
        const topicIds = this.selectedTopics.map(t => t._id);
        const response = await courseSubTopicService.getAllSubTopics(topicIds, search, page, 20);
        
        if (response && response.data && response.data.docs) {
             if (page === 1) {
                 this.subtopics = response.data.docs;
             } else {
                 this.subtopics = [...this.subtopics, ...response.data.docs];
                 this.subtopics = _.uniqBy(this.subtopics, '_id');
             }
             this.subTopicTotalPages = response.data.totalPages || 1;
             this.apiLoadedSubTopic = true;
        } else if (page === 1) {
             this.subtopics = [];
        }
        
      } catch (error) {
        console.error(error);
        if (page === 1) this.subtopics = [];
      } finally {
        this.loadingSubTopic = false;
      }
    },

    debouncedFetchSubTopics: _.debounce(function (e) {
        this.fetchSubTopics(this.subTopicSearch, 1);
    }, 500),

    loadMoreSubTopics() {
        if (this.subTopicPage < this.subTopicTotalPages) {
            this.subTopicPage++;
            this.fetchSubTopics(this.subTopicSearch, this.subTopicPage);
        }
    },

    /**
     * Fetch every subtopic page for the selected topics (respects current search).
     */
    async fetchAllSubTopicsPages(search = "") {
      if (!this.selectedTopics || !this.selectedTopics.length) {
        return [];
      }
      const topicIds = this.selectedTopics.map((t) => t._id);
      const pageSize = 100;
      let page = 1;
      let totalPages = 1;
      let all = [];

      do {
        const response = await courseSubTopicService.getAllSubTopics(
          topicIds,
          search,
          page,
          pageSize,
        );
        const docs = (response && response.data && response.data.docs) || [];
        all = all.concat(docs);
        totalPages = (response && response.data && response.data.totalPages) || 1;
        page += 1;
      } while (page <= totalPages);

      return _.uniqBy(all, "_id");
    },

    async selectAllSubTopics() {
      if (!this.selectedTopics.length) {
        this.$toast.warning("Please select at least one Topic first.");
        return;
      }
      if (this.selectingAllSubTopics) return;

      this.selectingAllSubTopics = true;
      this.loadingSubTopic = true;
      try {
        const all = await this.fetchAllSubTopicsPages(this.subTopicSearch);
        this.subtopics = all;
        this.subTopicPage = 1;
        this.subTopicTotalPages = 1;
        this.apiLoadedSubTopic = true;
        this.selectedSubTopics = [...all];
        if (all.length) {
          this.$toast.success(`Selected ${all.length} subtopic${all.length === 1 ? "" : "s"}`);
        } else {
          this.$toast.warning("No subtopics found to select");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Failed to select all subtopics");
      } finally {
        this.selectingAllSubTopics = false;
        this.loadingSubTopic = false;
      }
    },

    deselectAllSubTopics() {
      this.selectedSubTopics = [];
    },

    onSubTopicClick() {
        if (!this.selectedTopics.length) {
             this.$toast.warning("Please select at least one Topic first.");
             return;
        }
        this.showSubTopicDropdown = !this.showSubTopicDropdown;
        if (this.showSubTopicDropdown && !this.subtopics.length) {
            this.fetchSubTopics(this.subTopicSearch);
        }
    },

    toggleSubTopic(subtopic) {
        const index = this.selectedSubTopics.findIndex(s => s._id === subtopic._id);
        if (index === -1) {
            this.selectedSubTopics.push(subtopic);
        } else {
            this.selectedSubTopics.splice(index, 1);
        }
    },
    
    isSubTopicSelected(subtopic) {
        return this.selectedSubTopics.some(s => s._id === subtopic._id);
    },

    removeSubTopic(index) {
        this.selectedSubTopics.splice(index, 1);
    },

    hideSubTopicDropdown() {
        this.showSubTopicDropdown = false;
    },

    onConfigClick() {
        this.showConfigDropdown = !this.showConfigDropdown;
        if (this.showConfigDropdown && (!this.configurations || this.configurations.length === 0)) {
            this.fetchConfigurations(this.configSearch);
        }
    },
    
    toggleConfiguration(config) {
        const index = this.selectedConfigurations.findIndex(c => c._id === config._id);
        if (index === -1) {
            this.selectedConfigurations.push(config);
        } else {
            this.selectedConfigurations.splice(index, 1);
        }
        
        // Reset Topics when config changes significantly?
        // Maybe we want to keep selected topics if they still belong? 
        // For now, let's just re-fetch available topics.
        // optionally clear selected topics if they are no longer valid, but that requires more logic.
        // let's just re-fetch.
        this.fetchTopics();
    },
     
    isConfigSelected(config) {
        return this.selectedConfigurations.some(c => c._id === config._id);
    },

    removeConfiguration(index) {
        this.selectedConfigurations.splice(index, 1);
        this.fetchTopics();
    },
    
    hideConfigDropdown() {
        this.showConfigDropdown = false;
    },

    onTopicClick() {
        if (!this.selectedConfigurations.length) {
             this.$toast.warning("Please select at least one configuration first.");
             return;
        }
        this.showTopicDropdown = !this.showTopicDropdown;
        if (this.showTopicDropdown && !this.topics.length) {
            this.fetchTopics(this.topicSearch);
        }
    },

    toggleTopic(topic) {
        const index = this.selectedTopics.findIndex(t => t._id === topic._id);
        if (index === -1) {
            this.selectedTopics.push(topic);
        } else {
            this.selectedTopics.splice(index, 1);
        }
        // When topics change, re-fetch subtopics or clear them?
        // Let's re-fetch if we added, but if we removed, maybe we should remove related subtopics?
        // Simpler to just re-fetch available subtopics.
        this.fetchSubTopics();
    },
    
    isTopicSelected(topic) {
        return this.selectedTopics.some(t => t._id === topic._id);
    },

    removeTopic(index) {
        this.selectedTopics.splice(index, 1);
        this.fetchSubTopics();
    },

    hideTopicDropdown() {
        this.showTopicDropdown = false;
    },

    async createQuiz(type) {
      console.log("this.quiz.is_direct_check",this.is_direct_check);
      try {
        this.dataValidated = true;
        let hours = this.quiz.hours || 0;
        hours = hours * 60 * 60;
        let minutes = this.quiz.mins || 0;
        minutes = minutes * 60;
        const seconds = hours + minutes;
        const quizData = {
          quiz_type: this.quizType,
          name: this.quiz.name,
          ai_quiz_active: this.quiz.ai_quiz_active,
          description: this.quiz.description,
          instructor_id: this.instructor_id,
          is_published: false,
          created_at: this.quiz.created_at,
          chapter_id: this.selectedChapter?.value || null,
          video_id: this.selectedVideo?.id || null,
          passing_percentage: this.quiz.passing_percentage,
          result_delay_in_hours: this.quiz.result_delay_in_hours,
          ai_model: this.quiz.ai_model,
          duration: seconds,
          is_direct_check:this.is_direct_check === true ? true:false,
          is_zero_server:this.is_zero_server === true ? true:false,
          is_immediate_result: this.is_zero_server && this.is_immediate_result === true ? true : false,
          is_negative_marking: this.is_negative_marking === true ? true : false,
          negative_marking_per_question: this.is_negative_marking ? Number(this.negative_marking_per_question) || 0.25 : 0,
          configuration_id: this.selectedConfigurations.map(c => c._id),
          topic_id: this.selectedTopics.map(t => t._id),
          sub_topic_id: this.selectedSubTopics.map(st => st._id),
          ...(this.quizType === 'omr' ? { omr_sheet_layout: this.omr_sheet_layout || 'mdcat_manzil_180' } : {}),
          // checking_type only applies to subjective (daq) quizzes; sending it for other
          // types would put them on the submit-then-check path.
          ...(this.quizType === 'daq'
            ? {
                checking_type: this.checking_type || 'ai_only',
                teacher_check_window_hours:
                  this.checking_type === 'hybrid'
                    ? Number(this.teacher_check_window_hours) || DEFAULT_TEACHER_CHECK_WINDOW_HOURS
                    : DEFAULT_TEACHER_CHECK_WINDOW_HOURS,
              }
            : {}),
        };
        if (this.quizType === "omr") {
          quizData.is_immediate_result = true;
          quizData.is_zero_server = false;
          quizData.is_direct_check = false;
          quizData.result_delay_in_hours = 0;
        }
        const fields = [
          "quiz_type",
          "name",
          "description",
          "duration",
          "passing_percentage",
          "session_name",
          "session_description",
          "start_time",
          "end_time",
        ];
        // if (!this.selectedConfigurations || !this.selectedConfigurations.length) {
        //     throw new Error("Please select at least one Configuration");
        // }
        // if (!this.selectedTopics || !this.selectedTopics.length) {
        //     throw new Error("Please select at least one Topic");
        // }

        if (this.selectedConfigurations.length) {
            fields.push("configuration_id");
        }
        if (this.selectedTopics.length) {
            fields.push("topic_id");
        }
        if (this.selectedSubTopics.length) {
            fields.push("sub_topic_id");
        }
        if (this.selectedCourse.value) {
          quizData.course_id = this.selectedCourse.value || null;
          quizData.module_id = this.selectedModule.value || null;
          fields.push("course_id");
          fields.push("module_id");
        }
        if (this.selectedCourse.id) {
          quizData.course_id = this.selectedCourse.id || null;
          quizData.module_id = this.selectedModule.id || null;
          fields.push("course_id");
          fields.push("module_id");
        }
        let isDataValidated = await validatorService.validatorExtensive(
          fields,
          {
            ...quizData,
            session_name: this.session.name,
            session_description: this.session.description,
            start_time: this.session.start_time,
            end_time: this.session.end_time,
          }
        );
        if (isDataValidated) {
          throw new Error(isDataValidated);
        } else {
          let facultyIds = [];
          if (this.isDelayInResult) {
            if (this.quiz.result_delay_in_hours > 0) {
              this.result_delay_in_hours = this.quiz.result_delay_in_hours;
              //throw new Error("please select the radio button to select time");
            }
          } else {
            this.result_delay_in_hours = this.quiz.result_delay_in_hours;
          }
          if (this.selectedFaculties.length || this.quizType==='practice' || this.quizType==='omr') {

            if (this.quizType === "pop" && !this.selectedVideo.id) {
              this.errorVideo = true;
              console.log('hhhhhhhhhhhhhhhhh', this.errorVideo)
              throw new Error("Please select a video");
              
            }
            let sessionData = {};
            sessionData = {
              name: this.session.name,
              description: this.session.description,
              start_time: this.session.start_time,
              end_time: this.session.end_time,
              instructor_id: this.instructor_id,
              type: quizData.course_id ? "general" : "global",
              video_id: quizData.video_id,
              course_id: quizData.course_id,
              module_id: quizData.module_id,
              chapter_id: quizData.chapter_id || "",
              is_direct_check:this.is_direct_check=== true ? true:false
            };
            let v_session_data = {
              session_name: this.session.name,
              session_description: this.session.description,
              start_time: this.session.start_time,
              end_time: this.session.end_time,
            };
            const sessionFields = [
              "session_name",
              "session_description",
              "start_time",
              "end_time",
            ];
            let isSessionDataValidated =
              await validatorService.validatorExtensive(
                sessionFields,
                v_session_data
              );
            if (isSessionDataValidated) {
              throw new Error(isSessionDataValidated);
            }
            if (
              moment(this.session.start_time) > moment(this.session.end_time)
            ) {
              throw new Error("Ending time must be greater than starting time");
            }
            this.selectedFaculties.forEach((element) => {
              facultyIds.push(element.id);
            });
            // quizData._id=this.quiz._id;
            quizData.tags = this.selectedFaculties;
            quizData.course = this.selectedCourse;
            quizData.module = this.selectedModule;
            quizData.chapter = this.selectedChapter;
            quizData.video = this.selectedVideo;
            quizData.is_direct_check=this.is_direct_check;
            quizData.is_zero_server=this.is_zero_server;
            quizData.is_immediate_result=this.is_zero_server && this.is_immediate_result;
            if (quizData.course) {
              quizData.course.description = null;
              quizData.course.short_description = null;
            }
            console.log('quizData.course', quizData.course)
            let response;
            if (this.editMode) {
              if (this.newVersion) {
                quizData.quiz_id = this.quiz._id;
                response = await quizService.createNewVersion({
                  quiz: quizData,
                });
              } else {
                quizData.quiz_id = this.quiz._id;
                response = await quizService.updateQuiz(quizData);
              }
            } else {
              response = await quizService.createQuiz(quizData);
            }
            console.log("response---",response);
            if (response) {
              if (response.data.status === "success") {
                if (response.data.data.newVersionCheck) {
                  this.windowType = 22;
                } else {
                  if (response.data.data.quiz._id) {
                    if (
                      response.data.data.questions &&
                      response.data.data.questions.length
                    ) {
                      this.questions = response.data.data.questions;
                    }
                    this.quiz = response.data.data.quiz;
                    this.createdQuizId = response.data.data.quiz._id;
                    sessionData.quiz_id = this.createdQuizId;
                    this.saveSession(sessionData, type);
                  }
                }
              } else {
                this.$toast.info(response.data.message);
              }
            }
          } else {
            throw new Error("faculty: Atleast one faculty should be selected");
          }
        }
      } catch (error) {
        this.dataValidated = false;
        const apiMessage = extractApiErrorMessage(error);
        if (error.message && error.message.includes(":") && !error.response) {
          this.$toast.error(error.message.split(":")[1]);
          this.validation_errors = {};
          this.validation_errors[error.message.split(":")[0]] =
            error.message.split(":")[1];
        } else if (apiMessage) {
          this.$toast.error(apiMessage);
          if (error.response && error.response.data && error.response.data.message) {
            this.validation_errors = { name: error.response.data.message };
          }
        } else if (typeof error == "object") {
          if (Object.keys(error).length <= 2) {
            Object.keys(error).forEach((err) => {
              if (error[err] === "name is required") {
                this.$toast.error("Title is required");
              } else {
                this.$toast.error(error[err]);
              }
            });
          } else this.$toast.error("Missing or invalid fields");
          this.validation_errors = { ...error };
          if (this.validation_errors.name) {
            this.validation_errors.name = "Title is required";
          }
        } else if (error.response.data.message == "Validation Error") {
          this.$toast.error(error.response.data.errors[0].messages[0]);
        }
        // if (error.message) {
        //   this.$toast.error(error.message);
        // } else {
        //   this.$toast.error(error);
        // }
      }
    },
    openClose(type) {
      if (type === "module") {
        if (this.isModuleFocused) {
          this.isModuleFocused = false;
        } else {
          this.isModuleFocused = true;
        }
      } else if (type === "chapter") {
        if (this.isChapterFocused) {
          this.isChapterFocused = false;
        } else {
          this.isChapterFocused = true;
        }
      } else if (type === "video") {
        if (this.isVideoFocused) {
          this.isVideoFocused = false;
        } else {
          this.isVideoFocused = true;
        }
      }
    },
    selectCourse(theItem) {
      if (this.selectedCourse.name !== theItem.name) {
        this.clearModule();
      }
      this.selectedCourse = theItem;
      this.inputValueCourse = "";
      this.isCourseFocused = false;
      this.getModulesByCourseId(this.selectedCourse.value);
    },
    selectModule(theItem) {
       if(this.selectedModule.name !== theItem.name){
         this.clearVideo();
       }
      this.apiLoadedVideo = false;
      this.selectedModule = theItem;
      this.inputValueModule = "";
      this.isModuleFocused = false;
      this.moduleOrChapter = 1;
      this.moduleOrChapterId = theItem.value;
      this.getChapterByModuleId(theItem.value);
      
    },
    selectChapter(theItem) {
      this.apiLoadedVideo = false;
      this.selectedChapter = theItem;
      this.inputValueChapter = "";
      this.isChapterFocused = false;
      this.moduleOrChapter = 2;
      this.moduleOrChapterId = theItem.value;
      this.getVideos();
    },
    selectVideo(theItem) {
      this.selectedVideo = theItem;
      this.inputValueVideo = "";
      this.isVideoFocused = false;
    },
    itemVisible(item, inputValue) {
      let currentName = item.name?.toLowerCase();
      let currentInput = inputValue.toLowerCase();
      return currentName?.includes(currentInput);
    },
    onCourseClick() {
      if (this.isCourseFocused) {
        this.isCourseFocused = false;
      } else {
        this.isCourseFocused = true;
      }
      this.isModuleFocused = false;
    },
    onModuleClick() {
      if (this.isModuleFocused) {
        this.isModuleFocused = false;
      } else {
        this.isModuleFocused = true;
      }
    },
    onChapterClick() {
      if (this.isChapterFocused) {
        this.isChapterFocused = false;
      } else {
        this.isChapterFocused = true;
      }
    },
    onSessionClick() {
      if (this.isSessionFocused) {
        this.isSessionFocused = false;
      } else {
        this.isSessionFocused = true;
      }
    },
    setDelayHours() {
      this.quiz.result_delay_in_hours = 0;
    },
    validateStartDate() {
      let current_date = moment();
      let session_start_time = moment(this.session.start_time);
      if (session_start_time < current_date) {
        alert("Incorrect Start Date");
        this.session.start_time = "YYYY-MM-DDThh:mm";
      }
    },
    validateEndDate() {
      if (this.session.end_time < this.session.start_time) {
        alert("Incorrect End Date");
        this.session.end_time = "YYYY-MM-DDThh:mm";
      }
    },
    check() {
      let status = true;
      Object.keys(this.callcheck).forEach((key) =>
        status === !this.callcheck[key] ? false : status
      );
      return status;
    },
    fileDrop(event) {
      event.preventDefault();
      var input = document.createElement("input");
      input.type = "file";
      input.accept = ".csv,.json,text/csv,application/json";
      input.onchange = this.inputChangeHandler;
      input.files = event.dataTransfer.files;
      this.inputChangeHandler({ target: { files: input.files } });
    },
    omrJsonFileChooser() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".json,application/json";
      input.onchange = this.omrJsonInputChangeHandler;
      input.click();
    },
    omrJsonFileDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer && event.dataTransfer.files;
      if (!files || !files.length) return;
      this.omrJsonInputChangeHandler({ target: { files } });
    },
    getCorrectOptionLetter(question) {
      if (!question || !Array.isArray(question.options)) return "—";
      const idx = question.options.findIndex((o) => o.is_correct);
      if (idx < 0) return "—";
      return String.fromCharCode(65 + idx);
    },
    truncateText(text, maxLen) {
      const s = (text || "").trim();
      if (!s) return "—";
      if (s.length <= maxLen) return s;
      return `${s.slice(0, maxLen)}…`;
    },
    finishOmrQuiz() {
      if (!this.omrImportComplete) return;
      this.$toast.success(
        `OMR quiz "${this.quiz.name}" saved with ${this.questions.length} questions`
      );
      if (this.$parent && typeof this.$parent.getQuizzes === "function") {
        this.$parent.getQuizzes();
      }
      this.backMethod();
    },
    async omrJsonInputChangeHandler(e) {
      if (!e.target.files || !e.target.files.length) return;
      if (e.target.files.length > 1) {
        this.$toast.warning("You can only upload a single JSON file");
        return;
      }
      if (!this.createdQuizId) {
        this.$toast.error("Save quiz details first before importing JSON");
        return;
      }

      const file = e.target.files[0];
      this.omrJsonFileName = file.name;
      this.uploadingOmrJson = true;
      this.omrImportedCount = 0;
      this.omrImportTaxonomy = null;
      this.percentCompleted = 15;
      this.errors = [];
      this.warnings = [];
      this.uploadErrorSummary = "";

      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await omrService.importJsonToQuiz(this.createdQuizId, formData);
        this.percentCompleted = 100;

        if (response.data.status === "success") {
          const data = response.data.data || {};
          this.omrImportedCount = data.count || 0;
          this.omrImportTaxonomy = data.taxonomy || null;
          const parsed = applyOmrImportSuccess(data);
          applyUploadResultToVm(this, parsed);
          this.$toast.success(response.data.message || "OMR JSON imported");
          const quizResp = await quizService.getQuizUpdatedVersion(this.createdQuizId, { light: true });
          const { quiz, questions } = parseQuizUpdatedVersionResponse(quizResp);
          if (quiz) {
            this.quiz = quiz;
            if (quiz.tags && quiz.tags.length) {
              this.omrImportTaxonomy = this.omrImportTaxonomy || { tags: quiz.tags };
            }
          }
          if (questions.length) {
            this.questions = questions;
            this.omrImportedCount = questions.length;
          }
        } else {
          const parsed = applyOmrImportFailure(response.data);
          applyUploadResultToVm(this, parsed);
          this.$toast.error(parsed.summary);
        }
      } catch (error) {
        const respData = error.response && error.response.data;
        const status = error.response && error.response.status;
        const parsed = applyOmrImportFailure(
          respData || { message: error.message },
          status,
          { isNetworkError: !error.response }
        );
        applyUploadResultToVm(this, parsed);
        this.$toast.error(parsed.summary);
      } finally {
        this.uploadingOmrJson = false;
      }
    },
    async inputChangeHandler(e) {
      if (parseInt(e.target.files.length) > 1) {
        this.$toast.warning("You can only upload a single CSV or JSON file");
      } else {
        this.isCSVUpload = true;
        this.firstWindowHandler(5);
        this.percentCompleted = 0;
        this.uploadingFile = true;
        const originalFile = e.target.files[0];
        this.csvFileName = originalFile.name;
        this.questions = [];
        this.warnings = [];
        this.errors = [];
        this.uploadErrorSummary = "";

        let fileToUpload = originalFile;
        try {
          // JSON is converted to CSV client-side so uploadCsv + socket stay unchanged
          if (isQuizJsonFile(originalFile)) {
            fileToUpload = await convertQuizJsonFileToCsv(
              originalFile,
              this.quizType === 'daq' ? 'daq' : 'full',
            );
            this.percentCompleted = 10;
          }
        } catch (error) {
          this.uploadingFile = false;
          this.uploadingCSV = false;
          this.percentCompleted = 0;
          this.$toast.error(error.message || "Failed to parse JSON file");
          return;
        }

        try {
          var formData = new FormData();
          formData.append("file", fileToUpload);
          const upload = await quizService.uploadCsv(formData);
          const fileLink = upload.data.data.fileLink;
          this.percentCompleted = 20;
          csvSocketinit(
            fileLink,
            this.createdQuizId,
            (progress) => (this.percentCompleted = progress + 20),
            (data) => {
              this.uploadingFile = false;
              this.uploadingCSV = false;
              this.getCSVUploadResults({ data: { data: data } });
            },
            (error) => {
              const parsed = parseCsvSocketFatalError(error);
              applyUploadResultToVm(this, parsed);
              this.uploadingFile = false;
              this.uploadingCSV = false;
              this.percentCompleted = 0;
              this.$toast.error(parsed.summary);
            },
            this.quizType
          );
        } catch (error) {
          this.uploadingFile = false;
          this.uploadingCSV = false;
          this.percentCompleted = 0;
          this.$toast.error(
            (error.response && error.response.data && error.response.data.message) ||
              error.message ||
              "Failed to upload file"
          );
        }
      }
    },
    enableHours(val) {
      if (val == 1) {
        this.disable1 = false;
      }
      if (val == 0) {
        this.disable1 = true;
      }
    },

    onlyNumberValidation($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    globalClickEventHandler(e) {
      if (this.showConfigDropdown && this.$refs.configDropdownWrapper && !this.$refs.configDropdownWrapper.contains(e.target)) {
        this.hideConfigDropdown();
      }
      if (this.showTopicDropdown && this.$refs.topicDropdownWrapper && !this.$refs.topicDropdownWrapper.contains(e.target)) {
        this.hideTopicDropdown();
      }
      if (this.showSubTopicDropdown && this.$refs.subTopicDropdownWrapper && !this.$refs.subTopicDropdownWrapper.contains(e.target)) {
        this.hideSubTopicDropdown();
      }
    },
  },
  updated() {
    if (this.session.start_time != this.sessionOld.start_time) {
      this.sessionOld.start_time = this.session.start_time;
    }
    if (this.session.end_time != this.sessionOld.end_time) {
      if (this.session.end_time < this.session.start_time) {
        alert("Incorrect End Date");
        this.session.end_time = "YYYY-MM-DDThh:mm";
      } else {
        this.sessionOld.end_time = this.session.end_time;
      }
    }
  },
};
</script>

<style src="./create-quiz.css" scoped></style>
